import React from "react";
import { useSelector } from "react-redux";
import Loading from "../../../components/isLoading";
import { Button, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import "../../../assets/styles/components/TabStyles.css";
import PhotosGallery from "../../components/gallery/photos";
import VideoGallery from "../../components/gallery/videos";
import { NavLink } from "react-router-dom";

export default () => {
	const GalleryData = useSelector((state) => state.blogsGlobalStore);

	const [value, setValue] = React.useState("photos");

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	return (
		<div>
			{GalleryData.loading && !GalleryData.data[0] ? (
				<Loading />
			) : (
				<>
					<div
						style={{
							display: " flex",
							alignItems: "center",
							justifyContent: "space-between",
						}}
					>
						<Typography
							variant="h1"
							sx={{ fontSize: "25px", fontWeight: "700", paddingLeft: "20px" }}
						>
							Gallery
						</Typography>
						<div
							style={{
								padding: "15px",
								float: "right",
							}}
						>
							{value === "photos" ? (
								<Button
									variant="outlined"
									component={NavLink}
									to="/gallery/photos/new"
									sx={{
										color: "#E00186",
										border: "1px solid #E00186",
										"&:hover": {
											color: "#fff",
											backgroundColor: "#E00186",
											border: "1px solid #E00186",
										},
									}}
								>
									upload Image
								</Button>
							) : (
								<Button
									variant="outlined"
									component={NavLink}
									to="/gallery/videos/new"
									sx={{
										color: "#E00186",
										border: "1px solid #E00186",
										"&:hover": {
											color: "#fff",
											backgroundColor: "#E00186",
											border: "1px solid #E00186",
										},
									}}
								>
									upload Video
								</Button>
							)}
						</div>
					</div>
					<Box sx={{ width: "100%", typography: "body1" }}>
						<TabContext value={value}>
							<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
								<TabList
									onChange={handleChange}
									aria-label="lab API tabs example"
									TabIndicatorProps={{ style: { background: "#E00186" } }}
								>
									<Tab className="photo_tab" label="Photos" value="photos" />
									<Tab className="photo_tab" label="Videos" value="videos" />
								</TabList>
							</Box>
							<TabPanel value="photos" sx={{ padding: "10px 0px !important" }}>
								<PhotosGallery />
							</TabPanel>
							<TabPanel value="videos" sx={{ padding: "10px 0px !important" }}>
								<VideoGallery />
							</TabPanel>
						</TabContext>
					</Box>
				</>
			)}
		</div>
	);
};
